document.addEventListener('DOMContentLoaded', () => {
    const cursorDrag = document.querySelector('.js-cursor-drag');

    if (!cursorDrag) return;

    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;
    const speed = 0.1;  

    document.addEventListener('mousemove', (e) => {
        targetX = e.pageX;
        targetY = e.pageY;
    });

    function animate() {
        currentX += (targetX - currentX) * speed;
        currentY += (targetY - currentY) * speed;

        cursorDrag.style.left = `${currentX}px`;
        cursorDrag.style.top = `${currentY}px`;

        requestAnimationFrame(animate);
    }

    animate();

    const hoverTargets = document.querySelectorAll('.js-key-ingredients-top-carousel.is-active, .js-related-products, .js-not-found-carousel');

    hoverTargets.forEach(target => {
        target.addEventListener('mouseenter', () => {
            cursorDrag.classList.add('active');
        });
        target.addEventListener('mouseleave', () => {
            cursorDrag.classList.remove('active');
        });
    });
});